import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as api from '@/api/index';
import Vant from 'vant';
import 'vant/lib/index.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2'
import { ensureUserLngLat } from '@/utils/location'
Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.$api = api;
// 创建 Bus 实例（本质是一个空的 Vue 实例）
const Bus = new Vue()
// 挂载到 Vue 原型上，方便所有组件使用
Vue.prototype.$bus = Bus
// Best-effort: cache user's lng/lat early so order/after-sale APIs can include them in body.
// This may trigger a browser permission prompt on first visit (expected behavior).
ensureUserLngLat().catch(() => {})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
